/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Member Status
 * @export
 */
export const MemberStatus = {
    Regular: 'regular',
    DescendantRegular: 'descendant_regular',
    Sponsored: 'sponsored'
} as const;
export type MemberStatus = typeof MemberStatus[keyof typeof MemberStatus];


export function instanceOfMemberStatus(value: any): boolean {
    for (const key in MemberStatus) {
        if (Object.prototype.hasOwnProperty.call(MemberStatus, key)) {
            if (MemberStatus[key as keyof typeof MemberStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MemberStatusFromJSON(json: any): MemberStatus {
    return MemberStatusFromJSONTyped(json, false);
}

export function MemberStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberStatus {
    return json as MemberStatus;
}

export function MemberStatusToJSON(value?: MemberStatus | null): any {
    return value as any;
}

